import Menu from './Menu';
import ThemeToggle from './ThemeToggle';
import './PageHeader.css';

function PageHeader() {
  return (
    <header className="page-header">
      <Menu />
      <ThemeToggle />
    </header>
  );
}

export default PageHeader;
